import React from 'react';
import ReactDOM from 'react-dom';
import {SpeechProvider} from '@speechly/react-client';
import { Provider } from './context/context';
import App from './App';
import './index.css';

ReactDOM.render(
    <SpeechProvider appId="0264e1ac-d7b6-4395-9d0d-0263823df53d" language="en-US">
        <Provider>
            <App/> 
        </Provider>
    </SpeechProvider>,
    document.getElementById('root')
);
